// src/pages/personal/analytics/CustomerSection/components/SegmentationChart.tsx
import React from 'react';
import { PieChart } from '@/components/ui/Charts';
import { useTranslation } from 'react-i18next';
// Импортируем форматтеры
import { formatPercent, formatNumber } from '@/utils/Formatters';
import { useBusinessCurrency } from '@/hooks/useBusinessCurrency';

import styles from '../CustomerSection.module.css';

interface ChartData {
  name: string;
  value: number;
  percentage: number;
  color: string;
  revenue: number;
}

interface SegmentationChartProps {
  data: ChartData[];
}

export const SegmentationChart: React.FC<SegmentationChartProps> = ({ data }) => {
  const { t, i18n } = useTranslation('customer');
  const currentLocale = i18n.language;
  const { formatPrice } = useBusinessCurrency();
  
  // Преобразуем данные в формат для PieChart с использованием данных о цветах
  const pieData = data.map(item => ({
    name: item.name,
    value: item.value,
    color: item.color,
    revenue: item.revenue,
    percentage: item.percentage,
    displayName: item.name
  }));

  // Кастомный тултип с форматированием данных
  const renderCustomTooltip = (props: any) => {
    const { active, payload } = props;
    
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const percentage = data.percentage || (data.value / data.payload?.total || 0) * 100;
      
      return (
        <div className="bg-white p-2 border border-gray-200 shadow-md rounded-md">
          <p className="font-medium" style={{ color: data.color }}>{data.name}</p>
          <p className="text-gray-700">{t('source_distribution.clients')}: {formatNumber(data.value, 0, true, currentLocale)}</p>
          <p className="text-gray-700">{formatPercent(percentage, 1, true, currentLocale)}</p>
          <p className="text-gray-700">{t('source_distribution.revenue')}: {formatPrice(data.revenue)}</p>
        </div>
      );
    }
    
    return null;
  };

  return (
    <div className={styles.pieChartContainer}>
      <PieChart
        data={pieData}
        innerRadius={45}
        outerRadius={90}
        showLegend={false}
        showLabels={true}
        paddingAngle={1}
        tooltip={renderCustomTooltip}
        labelThreshold={5}
      />
    </div>
  );
};

export default SegmentationChart;